export var import_meta_url = require("url").pathToFileURL(__filename);
